import { Spinner, StyledButton } from "./styles";
import PropTypes from "prop-types";
import React from "react";

export const ModalButton = (props) => {
	const { label, onClick, loading, type, disabled } = props;

	return (
		<StyledButton
			className={
				type === "backgroundLess"
					? "border__background-less"
					: type === "backgroundLess-white"
					? "border__background-less-white"
					: ""
			}
			disabled={disabled}
			type={type}
			onClick={disabled ? null : onClick}
		>
			{loading ? <Spinner /> : label}
		</StyledButton>
	);
};

ModalButton.propTypes = {
	type: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	loading: PropTypes.bool,
	disabled: PropTypes.bool,
	onClick: PropTypes.func,
};
